import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: String }

  connect() {
    this.apply()
  }

  toggle(event) {
    const hidden = new Set(this.hidden)
    event.target.checked ? hidden.delete(event.target.value) : hidden.add(event.target.value)
    localStorage.setItem(this.storageKey, JSON.stringify([...hidden]))
    this.apply()
  }

  reset() {
    localStorage.removeItem(this.storageKey)
    this.apply()
  }

  apply() {
    const hidden = this.hidden
    const scope = this.element.closest("section") || document
    scope.querySelectorAll("[data-column]").forEach((el) => el.classList.toggle("hidden", hidden.includes(el.dataset.column)))
    this.element.querySelectorAll("input[type=checkbox]:not([disabled])").forEach((box) => { box.checked = !hidden.includes(box.value) })
  }

  get storageKey() {
    return `columns:${this.keyValue}`
  }

  get hidden() {
    try { return JSON.parse(localStorage.getItem(this.storageKey)) || [] } catch { return [] }
  }
}
